import { createRoute } from '@tanstack/react-router';
import { rotaPainel } from './painel';
import { Centro } from '../workspace/Centro';
import { NoCelular } from '../workspace/NoCelular';
import { usarTelaLarga } from '../workspace/Shell';
import { usarWorkspace } from '../workspace/contexto';


/**
 * A tela de trabalho: as abas e o editor.
 *
 * Só isso. A lateral, a conversa e a barra de estado moram na moldura
 * (`rotas/painel.tsx`), que não desmonta quando você troca de página — era
 * justamente esta rota que carregava a moldura antes e a jogava fora a cada
 * navegação.
 */
function Trabalho(): React.JSX.Element {
  const telaLarga = usarTelaLarga();
  const { estado, ir } = usarWorkspace();

  if (!telaLarga) return <NoCelular />;

  return (
    <Centro maquinaId={estado.maquina} estado={estado} aoMudar={ir} />
  );
}

export const rotaInicio = createRoute({
  getParentRoute: () => rotaPainel,
  path: '/',
  component: Trabalho,
});
